module.exports = __webpack_public_path__ + "assets/img/1.14290620.png";